// One browser-history boundary for screens and overlays; never issues logout.
let controller = null;
function backTarget(screen, authenticated) {
  if (screen === 'gameOver') return { screen: 'myGames', tab: 'finished' };
  if (screen === 'game') return { screen: 'myGames', tab: 'active' };
  return { screen: authenticated ? 'start' : 'login' };
}
function createBackNavigation(win, readScreen, onBack) {
  let layers = [], sequence = 0, pendingPop = false, disposed = false, screenBoundary = false;
  const root = () => ['start', 'login'].includes(readScreen());
  const mark = layer => ({ kelimo: true, layer: layer || null, screenBoundary });
  if (win.history.state?.kelimo && typeof win.history.state.screenBoundary === 'boolean') screenBoundary = win.history.state.screenBoundary;
  else win.history.replaceState(mark(), '');
  const synchronize = () => {
    if (disposed || pendingPop) return;
    if (win.history.state?.layer && !layers.some(layer => layer.id === win.history.state.layer)) {
      pendingPop = true; win.history.back(); return;
    }
    if (root() && screenBoundary) {
      screenBoundary = false; pendingPop = true; win.history.back(); return;
    }
    if (!root() && !screenBoundary) { screenBoundary = true; win.history.pushState(mark(), ''); }
    for (const layer of layers) if (!layer.pushed) { layer.pushed = true; win.history.pushState(mark(layer.id), ''); }
  };
  const pop = () => {
    if (disposed) return;
    if (pendingPop) { pendingPop = false; synchronize(); return; }
    if (layers.length) {
      const layer = layers.pop(); layer.closedByHistory = true; layer.close(); return;
    }
    screenBoundary = false;
    onBack();
  };
  win.addEventListener('popstate', pop);
  synchronize();
  return {
    screenChanged: synchronize,
    back() { if (layers.length || screenBoundary) win.history.back(); else onBack(); },
    layer(close) {
      const layer = { id: ++sequence, close, pushed: false, closedByHistory: false };
      layers.push(layer); synchronize();
      return () => {
        const index = layers.indexOf(layer); if (index >= 0) layers.splice(index, 1);
        if (!disposed && !layer.closedByHistory && layer.pushed && win.history.state?.layer === layer.id) {
          pendingPop = true; win.history.back();
        }
      };
    },
    dispose() { disposed = true; layers = []; win.removeEventListener('popstate', pop); },
  };
}
function installBackNavigation(...args) { controller = createBackNavigation(...args); return controller; }
function registerBackLayer(close) { return controller?.layer(close) || (() => {}); }
function goBack() { controller?.back(); }
module.exports = { backTarget, createBackNavigation, installBackNavigation, registerBackLayer, goBack };
